import { render, staticRenderFns } from "./BarberBookingModal.vue?vue&type=template&id=08f18154&scoped=true&"
import script from "./BarberBookingModal.vue?vue&type=script&lang=js&"
export * from "./BarberBookingModal.vue?vue&type=script&lang=js&"
import style0 from "./BarberBookingModal.vue?vue&type=style&index=0&id=08f18154&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f18154",
  null
  
)

export default component.exports